import { makeStyles } from '@rbx/ui';

const useFigureStyles = makeStyles()((theme) => ({
  figure: {
    marginBlockStart: theme.spacing(2),
    marginBlockEnd: theme.spacing(3),
    marginInlineStart: 0,
    marginInlineEnd: 0,
  },
}));
export default useFigureStyles;
